module.exports = __webpack_public_path__ + "static/media/ic_access_alarms_24px.d83b11f9.svg";